import axiosInstance from './axiosInstance';

const updateCardScores = async ({ token, outcomes }) => {
  try {
    const response = await axiosInstance.post('/cards/update-scores', outcomes, {
      headers: { Authorization: token },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error updating card scores: ' + error.message);
  }
};

export { updateCardScores };
